import CardTestimonial from '~/components/Molecules/CardTestimonial/CardTestimonial.vue'

export default {
  props: {
    title: {
      type: Object,
    },

    items: {
      type: Array,
    },

    subtitle: {
      type: String,
    },

    button: {
      type: Object,
    },
  },

  data() {
    return {
      cardTestimonial: CardTestimonial,

      swiperTestimonials: {
        slidesPerView: 1,
        spaceBetween: 70,
        allowTouchMove: true,
        resistanceRatio: 0,
        slideToClickedSlide: true,
        breakpoints: {
          480: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
            allowTouchMove: false,
          },
          1440: {
            slidesPerView: 3,
          },
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          el: '.swiper-navigation',
          clickable: true,
        },
      },
    }
  },
}
